export class PopOver extends HTMLElement {
    constructor() {
        super();
         
    }

    connectedCallback() {
        this.init();
    }

    disconnectedCallback() {
        this.removeEventListeners();
    }

    init() {
        const parent = this.parentElement;
        if (!parent) {
            return;
        }
        parent.style.position = 'relative'; // ensure parent is positioned for absolute child
        this.initEventListeners();
    }
        

    initEventListeners() {
        this.boundHandler = this.show.bind(this);
        this.boundHideHandler = this.hide.bind(this);
        this.parentElement.addEventListener('mouseenter', this.boundHandler);
        this.parentElement.addEventListener('mouseleave', this.boundHideHandler);
    }

    removeEventListeners() {
        this.parentElement.removeEventListener('mouseenter', this.boundHandler);
        this.parentElement.removeEventListener('mouseleave', this.boundHideHandler);    
    }

    show() {
        // remove title attribute temporarily to prevent default browser tooltip
        const parentTag = this.dataset.parent_tag || 'a';
        this.parentAnchor = this.closest(parentTag);
        if (!this.parentAnchor) {
            return;
        }
        this._title = this.parentAnchor.getAttribute('title');
        this.parentAnchor.removeAttribute('title');
    }

    hide() {
        // restore title attribute
        if (this._title && this.parentAnchor) {
            this.parentAnchor.setAttribute('title', this._title);
        }
    }

}

customElements.define('pop-over', PopOver);